/**
 * Formula operation enum.
 *
 * REF: ECMA-376, Third Edition, Part 1 | Section: 20.1.9.11
 */
export enum FORMULA_OPERATIONS {
    MultiplyDivide = "*/",
    AddSubtract = "+-",
    AddDivide = "+/",
    IfElse = "?:",
    AbsoluteValue = "abs",
    ArcTan = "at2",
    CosineArcTan = "cat2",
    Cosine = "cos",
    MaximumValue = "max",
    MinimumValue = "min",
    Modulo = "mod",
    PinTo = "pin",
    SineArcTan = "sat2",
    Sine = "sin",
    SquareRoot = "sqrt",
    Tangent = "tan",
    LiteralValue = "val",
};
